var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 166,
    viewBox: "0 0 107 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5254 59.2468L84.3454 16.6268C88.5254 14.2168 93.7454 17.2268 93.7454 22.0568V107.297C93.7454 110.507 92.0354 113.477 89.2454 115.087L15.4254 157.707C11.2454 160.117 6.02539 157.107 6.02539 152.277V67.0368C6.02539 63.8268 7.73539 60.8568 10.5254 59.2468Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98539 153.747V68.5071C8.98539 65.2971 10.6954 62.3271 13.4854 60.7171L87.3054 18.0971C88.7254 17.2771 90.2554 17.1271 91.6654 17.4171C89.7654 15.7071 86.8654 15.1571 84.3454 16.6171L10.5254 59.2371C7.74539 60.8471 6.02539 63.8171 6.02539 67.0271V152.267C6.02539 155.457 8.31539 157.807 11.0654 158.377C9.81539 157.257 8.98539 155.657 8.98539 153.747Z",
    fill: "#E2E8FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2052 59.8701L62.2452 63.3001L50.4552 83.7201L62.3152 90.4701L56.3152 100.86L44.4652 94.1101L32.6752 114.51L26.6352 111.07L38.4252 90.6601L26.5552 83.9001L32.5552 73.5201L44.4252 80.2701L56.2052 59.8701Z",
    fill: "#CAD6F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4549 87.7201L60.5249 84.8501L72.3849 91.6001L77.3149 94.4701L65.4549 87.7201Z",
    fill: "#F74417"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6351 115.07L36.7051 112.2L48.4851 91.7998L53.4251 94.6598L41.6351 115.07Z",
    fill: "#A63328"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2051 63.87L66.2651 61L72.3051 64.43L77.2451 67.3L71.2051 63.87Z",
    fill: "#F74417"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4249 84.27L54.4849 81.4L66.2649 61L71.2049 63.87L59.4249 84.27Z",
    fill: "#A63328"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.555 77.5199L42.625 74.6499L54.485 81.3999L59.425 84.2699L47.555 77.5199Z",
    fill: "#F74417"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.555 87.8999L36.625 85.0399L42.625 74.6499L47.555 77.5199L41.555 87.8999Z",
    fill: "#A63328"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2052 63.8701L77.2452 67.3001L65.4552 87.7201L77.3152 94.4701L71.3152 104.86L59.4652 98.1101L47.6752 118.51L41.6352 115.07L53.4252 94.6601L41.5552 87.9001L47.5552 77.5201L59.4252 84.2701L71.2052 63.8701Z",
    fill: "url(#paint0_linear_678_2455)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_678_2455",
    x1: 41.5552,
    y1: 91.1901,
    x2: 77.3152,
    y2: 91.1901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F83F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97250"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxFailedIcon);
export default __webpack_public_path__ + "static/media/tx-failed-icon.2626732dacee089a299d7506769f8b4b.svg";
export { ForwardRef as ReactComponent };